export const comments_5480349 = {"data":{"data":[],"links":{}}}